import { determineTimeFrame } from './determineTimeFrame'
import { toSnakeCase } from '@mfs/common/helpers/stringHelpers'

export const getDuplicatedFields = ({
  slices,
  voidWindowInfo,
  allFareBrandNames,
  listingPosition,
  fareBrands,
  searchRequestParams,
  isViewItemList = false,
}) => {
  const stops = slices?.[0]?.stops
  const timeFrame = determineTimeFrame(new Date(slices?.[0]?.departInfo?.time?.dateTime).getHours())

  const connections = stops /*direct, 1, multiple*/
  const isCancellable = !!Number(voidWindowInfo?.hoursLeft)
  let commonProps = {
    index: listingPosition /*this is the position of the listings card on the page*/,
  }

  if (!isViewItemList) {
    commonProps.initial_class = toSnakeCase(allFareBrandNames?.[0], { lowerCase: true }) /*cabin class*/
  }
  const upgrade_available = fareBrands?.length > 1 ? 'y' : 'n'
  const quantity =
    Number(searchRequestParams['num-adults'] || 0) +
    Number(searchRequestParams['num-infants'] || 0) +
    Number(searchRequestParams['num-children'] || 0)
  return { stops, timeFrame, connections, isCancellable, commonProps, upgrade_available, quantity }
}
